import { render, staticRenderFns } from "./notifications-bell.vue?vue&type=template&id=3042b1a8"
import script from "./notifications-bell.vue?vue&type=script&lang=js"
export * from "./notifications-bell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports